module.exports = __webpack_public_path__ + "static/img/008191947.9646b5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/008191947.png
// module id = /dX8
// module chunks = 0